// extracted by mini-css-extract-plugin
module.exports = {"icon":"NavigationNotifications_icon__mPms9"};